import {UI} from "../../../stem-core/ui/UIBase";
import {StyleSheet, registerStyle, styleRule} from "../../../stem-core/ui/Style";
import {LinkButton} from "../../../core/ui/LinkButton.jsx";
import {BlinkLogo, HamburgerIcon} from "../../../core/ui/SVGElements.jsx";
import {NavMobileExpanded} from "./NavMobileAnimated.jsx";
import {Nav, PAGES} from "./Nav.jsx";
import {MOBILE_NAV_HEIGHT} from "../../Constants.js";
import type {NodeAttributes} from "../../../stem-core/ui/NodeAttributes";


export class NavMobileStyle extends StyleSheet {
    @styleRule
    navMobileContainer = {
        backgroundColor: this.themeProps.NAVBAR_BACKGROUND,
        boxShadow: this.themeProps.NAVBAR_BOX_SHADOW,
        position: "fixed",
        zIndex: 10000,
        padding: "0 12px",
        height: MOBILE_NAV_HEIGHT,
        width: "100vw",
        display: "flex",
        flexDirection: "column",
    };

    @styleRule
    nav = {
        height: "100%",
        display: "flex",
    };

    @styleRule
    activeHeaderElementContainer = {
        cursor: "pointer",
        color: this.themeProps.NAV_MOBILE_COLOR,
        fontSize: 18,
        padding: "0 16px",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flex: 1,
    };

    @styleRule
    menuIconContainer = {
        height: "100%",
        display: "flex",
        alignItems: "center",
        width: 24,
        cursor: "pointer",
    };

    @styleRule
    accountIconContainer = {
        height: "100%",
        display: "flex",
        alignItems: "center",
        width: 24,
        position: "relative",
    };

    @styleRule
    accountIconLink = {
        position: "absolute",
        right: 0,
    };
}

interface NavMobileOptions {
    currentActivePage?: any;
}

@registerStyle(NavMobileStyle)
export class NavMobile extends Nav<NavMobileOptions> {
    extraNodeAttributes(attr: NodeAttributes) {
        attr.addClass(this.styleSheet.navMobileContainer);
    }

    render() {
        const {styleSheet} = this;
        const {currentActivePage} = this.options;
        const iconItems = PAGES.filter(page => page.Icon);

        return [
            <div className={styleSheet.nav}>
                <div className={styleSheet.menuIconContainer}>
                    <HamburgerIcon size={12} color="#E8F0F2"/>
                </div>
                <div className={styleSheet.activeHeaderElementContainer}>
                    {currentActivePage?.title?.toString() || <BlinkLogo size={16}/>}
                </div>
                <div className={styleSheet.accountIconContainer}>
                    {iconItems.map(page => {
                        const active = page === this.options.currentActivePage;
                        const {Icon, IconActive} = page;
                        return (
                            <LinkButton href={page.href} className={styleSheet.accountIconLink}>
                                {active ? <IconActive size={28} /> : <Icon size={24} />}
                            </LinkButton>
                        );
                    })}
                </div>
            </div>,
        ];
    }

    onMount() {
        super.onMount();
        this.addClickListener(() =>
            NavMobileExpanded.show({currentActivePage: this.options.currentActivePage}));
    }
}
